import React, { useEffect, useState } from "react";
import axios from "axios";
import { Container, TextField, Button, Typography, Box, CircularProgress,Paper, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { saveNotification } from "../utils/notifications.jsx"; 
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const Bonafide = () => {
  const [form, setForm] = useState({
    name: "",
    employee_id: "",
    department: "",
    reason: "",
    address: "",
    candidateEmail: "",
    hrEmail: ""
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [hrManagers, setHrManagers] = useState([]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
     
        const userResponse = await axios.get(`${API_URL}/api/user/current`, {withCredentials: true});
        const employeeId = userResponse.data.employee_id;
        
        if (employeeId) {
       
          setForm(prevForm => ({
            ...prevForm,
            employee_id: employeeId
          }));
          
            const token = localStorage.getItem('token');
    if (!token) {
      alert("No authentication token found. Please log in.");
      return;
    }
  
    const payload = JSON.parse(atob(token.split('.')[1]));
    const company_id = payload.company_id;
          const employeeResponse = await axios.get(`${API_URL}/api/employees/${employeeId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                
              }
            }
          );
          const employeeDepartment = employeeResponse.data.data.department;
          if (employeeResponse.data.success && employeeResponse.data.data) {
            const employeeData = employeeResponse.data.data;
            setForm(prevForm => ({
              ...prevForm,
              name: `${employeeData.firstName} ${employeeData.lastName}`,
              department: employeeData.department || "",
              candidateEmail: employeeData.companyemail || ""
            }));
          }
          
        
          try {
            const token = localStorage.getItem('token');
            if (!token) {
              alert("No authentication token found. Please log in.");
              return;
            }
            const hrResponse = await axios.get(`${API_URL}/api/roles/employees/byrole/HR Manager`, {
              headers: {
                Authorization: `Bearer ${token}`
              }
            });
            if (hrResponse.data.success && hrResponse.data.data) {
              const hrs = hrResponse.data.data;
              setHrManagers(hrs);
              
              // Automatically select the department-specific HR manager if found
              const deptHr = hrs.find(hr => hr.department === employeeDepartment);
              if (deptHr) {
                setForm(prevForm => ({
                  ...prevForm,
                  hrEmail: deptHr.companyemail || ""
                }));
              } else if (hrs.length > 0) {
                // Fallback: first HR manager
                setForm(prevForm => ({
                  ...prevForm,
                  hrEmail: hrs[0].companyemail || ""
                }));
              }
            }
          } catch (hrErr) {
          }
        }
      } catch (err) {
        setError("Failed to load employee information");
      }
    };

    fetchUserData();
  }, []);

  

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");
  
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        alert("No authentication token found. Please log in.");
        return;
      }
      const payload = JSON.parse(atob(token.split(".")[1]));
      const company_id = payload.company_id;  // ✅ extract company_id
  
      await axios.post(
        `${API_URL}/api/bonafide`,  // ✅ send company_id in query
        form,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          },
          withCredentials: true
        }
      );
  
      saveNotification({
        id: Date.now(),
        message: "New Bonafide Request Submitted",
        date: new Date().toISOString(),
        link: "/bonafiedlist",
        read: false
      });
  
      alert("Request Submitted Successfully");
      setForm({
        ...form,
        reason: "",
        address: ""
      });
    } catch (err) {
      setError("Failed to submit the request. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <Container maxWidth="1500px" sx={{ py: 4 }}>
    <Paper elevation={3} sx={{ p: 4,  borderRadius: 2, // Rounded corners
  border: '2px solid',
  borderColor: 'grey.300', // Subtle professional border
  boxShadow: 4,  }}>
      
          <Typography variant="h4" gutterBottom fontWeight="bold">
            Bonafide Request
          </Typography>
          <form onSubmit={handleSubmit}>
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField 
                fullWidth 
                margin="normal" 
                label="Name" 
                name="name" 
                value={form.name} 
                onChange={handleChange} 
                required 
              />
              <TextField 
                fullWidth 
                margin="normal" 
                label="Employee ID" 
                name="employee_id" 
                value={form.employee_id} 
                InputProps={{readOnly:true}}
                variant="filled"
              />
            </Box>

            <TextField 
              fullWidth 
              margin="normal" 
              label="Department" 
              name="department" 
              value={form.department} 
              onChange={handleChange} 
              required 
            />

            <TextField
              fullWidth
              margin="normal"
              label="Candidate Email"
              name="candidateEmail"
              type="email"
              value={form.candidateEmail}
              onChange={handleChange}
              required
            />

            <FormControl fullWidth margin="normal" required>
              <InputLabel id="hr-email-label">HR Email</InputLabel>
              <Select
                labelId="hr-email-label"
                name="hrEmail"
                value={form.hrEmail}
                onChange={handleChange}
                label="HR Email"
              >
                {hrManagers.map((hr) => (
                  <MenuItem key={hr.companyemail} value={hr.companyemail}>
                    {hr.companyemail}
                  </MenuItem>
                ))}
                {hrManagers.length === 0 && form.hrEmail && (
                  <MenuItem value={form.hrEmail}>{form.hrEmail}</MenuItem>
                )}
              </Select>
            </FormControl>
            
            <TextField 
              fullWidth 
              margin="normal" 
              label="Address" 
              name="address" 
              value={form.address} 
              onChange={handleChange} 
              required 
            />
            
            <TextField 
              fullWidth 
              margin="normal" 
              label="Reason" 
              name="reason" 
              multiline 
              rows={3} 
              value={form.reason} 
              onChange={handleChange} 
              required 
            />

            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              <Button 
                type="submit" 
                variant="contained" 
                color="primary" 
                sx={{ width: "120px" }} 
                disabled={isLoading}
              >
                {isLoading ? <CircularProgress size={24} /> : "Submit"}
              </Button>
            </Box>
            <TextField
              fullWidth
              margin="normal"
              value="The Bonafide Certificate will be issued within 2 working days."
              InputProps={{ readOnly: true }}
            />
          </form>
          {error && <Typography color="error" align="center">{error}</Typography>}
      
        </Paper>
      </Container>
  
  );
};

export default Bonafide;